import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';

import { AuthService, OrganizationService, SettingsService } from '../../services';
import { LoginModalComponent } from '../../modals/login-modal/login-modal.component';
import { PlatformService } from 'src/app/services/platform.service';

@Component({
    selector: 'app-public-page-shell',
    templateUrl: './public-page-shell.component.html',
    styleUrls: ['./public-page-shell.component.scss']
})
export class PublicPageShellComponent implements OnInit {
    @Input() showBackButton: boolean = false;
    @Input() isFlyerPage: boolean = false;
    @Input() showProgressBar: boolean = false;

    public year: number = new Date().getFullYear();
    public isMobilePlatform: boolean = false;

    constructor(
        private location: Location,
        private router: Router,
        private modalCtrl: ModalController,
        private orgService: OrganizationService,
        private platformService: PlatformService,
        public settings: SettingsService,
        public auth: AuthService,
    ) {}

    ngOnInit() {
       this.isMobilePlatform = this.platformService.isMobilePlatform();
    }

    navigate(type: 'user' | 'customer') {
        if (type === 'user') {
            return this.router.navigate(['/' + this.orgService.organization.id + '/dashboard/edit-user']);
        }

        return this.router.navigate(['/' + this.orgService.organization.id + '/customer-token', localStorage.getItem('customerUpdateToken')]);
    }

    back() {
        if (this.isFlyerPage) {
            return this.router.navigate(['/' + this.orgService.organization.id]);
        }

        if (window.history.length > 2) {
            return this.location.back();
        }

        return this.router.navigate(['/' + this.orgService.organization.id]);
    }

    async openLoginModal() {
        const modal = await this.modalCtrl.create({
            component: LoginModalComponent,
            cssClass: 'login-modal',
            backdropDismiss: false,
            keyboardClose: false
        });

        await modal.present();
        await modal.onDidDismiss();
    }
}
